import React from "react";
import { NewsGridCard } from "@modules/study/common/news";
import posts from "@_fakeData/posts.json";
import styles from "./middle_section.module.scss";

export const NewsMiddleSection = ({ mustReadNews }) => {
  return (
    <section className={styles.middle_section}>
      <div className="container">
        <div className={styles.title_wrapper}>
          <h2 className={styles.title}>Must Read</h2>

          {/* <div className={styles.sub_text}>
            Everything you need to know about the re-reboot of your favourite
            childhood flick.
          </div> */}
        </div>

        <div className={styles.news_card_wrapper}>
          {mustReadNews &&
            mustReadNews.map((post, i) => {
              return (
                <NewsGridCard
                  key={i}
                  data={post}
                  customClasses={{
                    cardClass: styles.news_card,
                    titleClass: styles.news_card_title,
                    featureImageClass: styles.news_feature_image_wrapper,
                  }}
                />
              );
            })}
        </div>
      </div>
    </section>
  );
};

export default NewsMiddleSection;
